module.exports = __webpack_public_path__ + "static/b018d6ded2a3116388ea99683a96815289c8c674760d0ed1ac926ee372ca5641-d4ba9a2c2dc35c893b2282dcbb369738.png";